import { PersonalImagesType } from "pages/Profile/EditProfile/PersonalDetails/ImageUpload/types";
import { useEffect, useState } from "react";
import { useAppSelector } from "slice";
import { useGetUserPhotosQuery } from "slice/user";

export const useImageSection = () => {
    const {
        data: { id: user_id },
    } = useAppSelector((state) => state.model);
    const { data, refetch } = useGetUserPhotosQuery(user_id, {
        refetchOnMountOrArgChange: true,
        skip: !user_id,
    });

    const [images, setImages] = useState<PersonalImagesType>({});

    useEffect(() => {
        if (data && data.length > 0) {
            const profile =
                data.find((image: Image) => image.image_type === "profile") ||
                {};
            const cover =
                data.find((image: Image) => image.image_type === "cover") || {};

            setImages({
                profile,
                cover,
            });
        } else {
            setImages({});
        }
    }, [data, refetch]);

    const handleError = () => {
        refetch();
    };

    return {
        images,
        handleError,
    };
};
